module.exports = __webpack_public_path__ + "img/tenant-hub-logo-regular.d4abfab0.png";